import { Model } from '../model';

export class WordPressPostCategoryModel extends Model {
  /**
   * The custom fields of the category.
   */
  custom_fields: any;

  /**
   * The id of the model.
   */
  id?: number;

  /**
   * The name of the category.
   */
  name?: string;

  /**
   * The route of the model.
   */
  route?: string | string[];

  /**
   * The query parameters of the route.
   */
  routeQueryParams?: { [key: string]: string };

  /**
   * The slug of the category.
   */
  slug?: string;

  /**
   * Handle model booted.
   */
  booted() {
    this.route = ["/blog"];
    this.routeQueryParams = { categories: `${this.slug}-${this.id}` };
  }
}
